import React from "react";
import EmployeeList from "../modules/EmployeeList/EmployeeList";

export default function EmployeeListPage() {
  return <EmployeeList />;
}